package one.devsbox.shared.devices

import one.devsbox.commons.EType

enum class ScreenRotation(override val mask: Int,
    var angle:Int) : EType {
    /**
     * MASK: 2
     */
    HORIZONTAL(2, 0),

    /**
     * MASK: 4
     */
    VERTICAL(4,90),
    /**
     * MASK: 8
     */
    HORIZONTAL_REVERSED(8, 180),
    /**
     * MASK: 16
     */
    VERTICAL_REVERSED(16, 270);

    companion object : EType.Finder<ScreenRotation>(entries)
}

val ScreenRotation.Companion.ALL get() = ScreenRotation.entries.sumOf { it.mask }